import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DocumentRequestService } from 'src/app/v2-node-api/services/document-request.service';
import { NodesService } from '../../+my-libraries/+sites/document-library/shared/services/nodes.service';
import { StorageService } from 'src/shared/services/storage/storage.service';

@Component({
  selector: 'dilog-see-document',
  templateUrl: './dilog-see-document.component.html',
  styleUrls: ['./dilog-see-document.component.scss']
})
export class DilogSeeDocumentComponent implements OnInit {
 public file :any;
 public request :any;
 public blobFile:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<DilogSeeDocumentComponent>,
  private formBuilder: FormBuilder,
  private dialog: MatDialog,
  protected documentRequestService: DocumentRequestService, 
   private nodeService: NodesService,
   private storage: StorageService) { }

  ngOnInit(): void {

    const token = this.storage.getAsync({ key: "token" });
    this.file=this.data.document.data;
this.request=this.data.request;
    this.nodeService.loadFile(this.file.id, token, false).then((res)=>{
      this.blobFile=res;
    })
  }
  validateDocument(){
    this.documentRequestService
                .uploadFile(
                  this.data.request._id,
                  this.data.document._id,
                  {
                    data: this.data.document.data,
                    status:'uploaded'
                  }
                )
                .subscribe((res: any) => {
                  this.dialogRef.close(res);  
                });
              
  }

  rejectDcoument(){
    this.documentRequestService
    .uploadFile(
      this.data.request._id,
      this.data.document._id,
      {
        data: {name:this.data.document.title},
        status:'unvalidated'
      }
    )
    .subscribe((res: any) => {
      this.nodeService.delete(this.file.id).then((result) => {
        this.dialogRef.close(res);  
      });
     
    });
   
  }
}
